import { render, staticRenderFns } from "./GabDlrz.vue?vue&type=template&id=266c54ed&scoped=true&"
import script from "./GabDlrz.vue?vue&type=script&lang=js&"
export * from "./GabDlrz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "266c54ed",
  null
  
)

export default component.exports